import { render, staticRenderFns } from "./ModattaStepSummary.vue?vue&type=template&id=621a889a"
import script from "./ModattaStepSummary.vue?vue&type=script&lang=js"
export * from "./ModattaStepSummary.vue?vue&type=script&lang=js"
import style0 from "./ModattaStepSummary.vue?vue&type=style&index=0&id=621a889a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports